// js
 document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.swiper_cst', {
      slidesPerView: 6,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView:6,
        },
        768: {
          slidesPerView: 3,
        },
        480: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1.5,
        },
      },
    });
  });

// corporate gift box

 document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.gift-swiper', {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView:4,
        },
        768: {
          slidesPerView: 3,
        },
        480: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1.5,
        },
      },
    });
  });

// shop the look

document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.shop-look-slider', {
      slidesPerView:1,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView:1,
        },
        768: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 1,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });
  });

// testimonal



document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.testimonal-slider', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true, // autoplay के लिए loop true होना चाहिए
    autoplay: {
      delay: 3000, // 5 सेकंड का delay
      disableOnInteraction: false, // यूजर interaction के बाद भी autoplay continue रहे
    },
    // navigation हटाया गया
    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      480: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
});
